module.exports = __webpack_public_path__ + "img/share_icon.cb5486ba.svg";